import { styled } from "@styles";

export const Wrapper = styled.div`
`;

export const Div = styled.div`
   position: relative; 
   padding-bottom: 56.25%; 
   height: 0; 
   overflow: hidden; 
   max-width: 100%; 
`;

export const Iframe = styled.iframe`
  position: absolute;
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
`;
